import { Component, OnInit } from '@angular/core';

import { UserLoginService } from './service/aws/user.login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'AWS-ME';

  constructor(private userLoginService: UserLoginService) {
  }

  ngOnInit() {
    this.userLoginService.isAuthenticated(null, null);
  }
}
